// extracted by mini-css-extract-plugin
export default {"main_icons":"Main_main_icons__plxkQ","main_icon":"Main_main_icon__GU-aM","icon_title":"Main_icon_title__ZxC4u","about":"Main_about__Ny356"};